// extracted by mini-css-extract-plugin
export var table = "_xq-0";